import { render, staticRenderFns } from "./Title2.vue?vue&type=template&id=393cb279&scoped=true&"
import script from "./Title2.vue?vue&type=script&lang=js&"
export * from "./Title2.vue?vue&type=script&lang=js&"
import style0 from "./Title2.vue?vue&type=style&index=0&id=393cb279&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393cb279",
  null
  
)

export default component.exports